import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogTitle,
} from "../alert-dialog";
import { LucideTriangleAlert } from "lucide-react";
import { AlertAction } from "./AlertDialog";
const Icon = () => (
  <div className="bg-yellow-100 rounded-full">
    <LucideTriangleAlert strokeWidth={2} 
    className="h-9 w-9 text-yellow-600 m-2 flex-shrink-0"
     />
  </div>
);

 type WarningDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  title?: string
  description?: string,
  action? : AlertAction
}

const WarningDialog = ({ open, onOpenChange, title, description, action } : WarningDialogProps) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>

      <AlertDialogContent className="z-50">
        <AlertDialogHeader className="flex items-center gap-2">
          <Icon />
          <AlertDialogTitle className="font-bold text-xl">
            {
              title || "Warning"
            }
          </AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogDescription className="text-center ">
          {description ||  "Please check the information and try again."}
        </AlertDialogDescription>
        <AlertDialogFooter className="flex sm:justify-center sm:mt-3">
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={() => {
              action?.onClick?.()
              onOpenChange(false)
            }}
          >
            {action?.label || "Continue"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
      <AlertDialogOverlay className="z-40 bg-black/50" />

    </AlertDialog>
  );
};

export default WarningDialog;
